import { Component, OnInit } from '@angular/core';
import { RouterLink }          from '@angular/router';
import {environment} from "../../../environments/environment";

@Component({
    selector: 'imprint',
    templateUrl: './imprint.component.html'
})
export class ImprintComponent implements OnInit {
    env = environment;

    constructor() { }

    ngOnInit() {
    }

}
